import { Component } from '@angular/core';

@Component({
    selector: 'app-filter-container',
    templateUrl: './filter-container.component.html',
    styleUrls: ['./filter-container.component.scss'],
    standalone: false
})
export class FilterContainerComponent {}
